import * as React from "react";

const DirectorPage : React.FC = () => {
    return (
        <React.Fragment>
            <div className={"director"}>
                <img src={"/images/header_incho_2025.png?2025050222"} className={"header"} alt={"宮岡クリニック 医師紹介 - 通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
                <section>
                <h1 style={{fontWeight:"bold"}}>
                    名誉院長　宮岡哲郎（みやおか　てつろう）
                </h1>
                <figure className={"figure"}>
                    <img src={"/images/miyaoka_tetsurou.jpg"} alt={"宮岡クリニック 名誉院長 宮岡哲郎"}/>
                    <div>名誉院長 宮岡哲郎</div>
                </figure>
                <p>昭和50年 奈良県立医科大学卒業</p>
                <p>
                    虎ノ門病院外科レジデントを経て、北野病院外科、大阪北逓信病院に勤務
                </p>
                <p>
                    平成14年11月「宮岡クリニック」を開業
                </p>
                <p>
                    平成17年7月「医療法人ゆうあい会」設立
                </p>
                <ul>
                    <li>日本大腸肛門病学会(肛門領域)-指導医・専門医</li>
                    <li>日本臨床肛門病学会-技能指導医</li>
                    <li>日本消化器内視鏡学会-専門医</li>
                    <li>日本消化器外科学会-認定医</li>
                    <li>麻酔科-標榜医</li>
                    <li>日本外科学会-専門医</li>
                </ul>
                <h2 className={"with-border"}>ご挨拶</h2>
                <div className={"message"}>
                    <p>
                        勤務医としての27年間の経験と技術を生かして、大阪市港区市岡で宮岡クリニックを開院しております。<br/>
                        地域の皆様のかかりつけ医として生活習慣病の治療に貢献しております。皆様の気になられることをどうぞご相談ください。<br/>
                        専門は、消化器疾患(胃、大腸、肛門)で、内視鏡検査(胃カメラ、大腸内視鏡検査、ポリープ切除）、痔、日帰り手術です。<br/>
                        開業後胃カメラ一万件以上、大腸カメラ5000件以上、痔核手術800例以上、痔瘻手術300例以上おこなってきました。<br/>
                        2019年より長男が診療に加わり、さらなる検査・治療の充実を図っていきたいと思います。
                    </p>
                </div>
                <h2 className={"with-border"}>日本大腸肛門病学会　指導医・専門医</h2>
                <div className={"center"}>
                    <img src={"/images/nintei.jpg"}/>
                </div>
                <p>
                    日本大腸肛門病学会には、約6000人の医師が加入しておりますが、肛門関係の指導医、専門医は全国に200名余しかおりません。
                </p>
                </section>
                <section>
                    <h1 style={{fontWeight:"bold"}}>院長 医学博士 宮岡雄太（みやおか　ゆうた）</h1>
                    <figure className={"figure"}>
                        <img src={"/images/miyaoka_yuta.jpg"} alt={"宮岡クリニック 院長 宮岡雄太"}/>
                        <div>院長 宮岡雄太</div>
                    </figure>
                    <p>
                        平成20年　大阪医科大学卒業
                    </p>
                    <p>
                        京都大学医学部附属病院にて研修<br/>
                        大阪医科大学付属病院にてレジデント研修<br/>
                        藤田胃腸科病院・南大阪病院・大阪医大三島南病院勤務<br/>
                    </p>
                    <p>
                        大阪医科大学にて博士課程修了
                    </p>
                    <p style={{"fontWeight": "bold"}}>
                        所属学会
                    </p>
                    <ul>
                        <li>日本外科学会-専門医</li>
                        <li>日本大腸肛門病学会</li>
                        <li>日本消化器内視鏡学会専門医</li>
                    </ul>
                    <h2 style={{clear: "both"}} className={"with-border"}>ご挨拶</h2>
                    <div className={"message"}>
                        <p>
                            院長の宮岡雄太です。2019年10月より勤務しております。<br/>
                            父親である名誉院長のやり方を踏襲しつつ、病院勤務時代に得た知識・技術を地域の皆様に還元していきたいと思います。<br/>
                            大学院では脂肪肝に関する研究で博士課程を修了いたしました。
                        </p>
                    </div>
                    <h2 className={"with-border"}>大阪医科大学 医学博士 学位記</h2>
                    <div className={"center"}>
                        <img src={"/images/miyaoka_yuta_diploma.jpg"}/>
                    </div>
                </section>
                <div style={{marginBottom: "100px"}}></div>
            </div>
        </React.Fragment>
    );
}

export default DirectorPage;
